import Box from '@/components/UI/box/Box';
import React, { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import Button from '@/components/UI/button/Button';
import { calendarSelector } from '@/helpers/props';
import ScrollDatepicker from '@/components/datepicker/scrollRangeDatepicker/ScrollDatepicker';
import Drawer from '@/components/UI/drawer/Drawer';
import Header from '../header/Header';
import Typography from '@/components/UI/typography/Typography';
import { useRouter } from 'next/router';
import FooterDescription from '@/components/datepicker/instanstDescriptions/InstanstPeakDescription';
import useRemoveBodyScroll from '@/components/houses/_hooks/useRemoveBodyScroll';
import styles from './CalendarMobile.module.scss';
interface CalenderMobileProps {
  open: boolean;
  onClose: () => void;
  resetFilter?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  handleDatePickerChange: (dates: any) => void;
  calendarRef: any;
  isFull?: boolean;
  backIcon?: boolean;
  hasInstant?: boolean;
  footer?: React.ReactNode;
  withTooltip?: boolean;
  minDays?: number;
  headerChildren?: React.ReactNode;
  banner?: ReactNode;
  isMidterm?: boolean;
}
const CalendarMobile: FC<CalenderMobileProps> = ({
  open,
  onClose,
  resetFilter,
  handleDatePickerChange,
  calendarRef,
  isFull = false,
  backIcon = false,
  hasInstant = false,
  footer,
  withTooltip,
  minDays,
  headerChildren,
  banner,
  isMidterm
}) => {
  useRemoveBodyScroll(open);
  const router = useRouter();
  const calendar: any = useSelector(state => calendarSelector(state));
  const {
    checkin,
    checkout
  } = useSelector(state => state.basicFilters);
  const isHome = router.pathname === '/';
  const handleSubmit = () => {
    handleDatePickerChange({
      checkin,
      checkout,
      submited: true
    });
  };
  const getDaysBetweenDates = (timestamp1: number, timestamp2: number) => {
    const earlerDay = new Date(timestamp1).getTime();
    const laterDay = new Date(timestamp2).getTime();
    const diff = Math.round((laterDay - earlerDay) / (60 * 60 * 24));
    return diff;
  };
  const formatTime = time => {
    const timeDate = new Date(time * 1000);
    const [week, month, day] = timeDate.toLocaleDateString('fa-IR', {
      day: 'numeric',
      month: 'long',
      weekday: 'long'
    }).split(' ');
    return `${week} , ${month} ${day}`;
  };
  const handlePass = () => {
    handleDatePickerChange({
      checkin,
      checkout,
      submited: true
    });
  };
  const handleReset = (e: React.MouseEvent<HTMLButtonElement>) => {
    calendarRef?.current?.cleanValue();
    if (resetFilter) resetFilter(e);
  };
  return <Drawer fullHeight open={open} onClose={() => onClose()} data-sentry-element="Drawer" data-sentry-component="CalendarMobile" data-sentry-source-file="CalendarMobile.tsx">
      <Header backIcon={backIcon} handleClose={() => onClose()} data-sentry-element="Header" data-sentry-source-file="CalendarMobile.tsx" />
      {open && <Box className={styles['calender-mobile-wrapper']}>
          {banner}
          <ScrollDatepicker calendar={isFull || minDays ? calendar?.calendar : calendar} dates={{
        checkin,
        checkout
      }} onChange={handleDatePickerChange} dateRef={calendarRef} withoutStyle isFull={isFull} withTooltip={withTooltip} minDays={minDays} nextRangeMonths={isMidterm ? 365 : calendar?.differenceInDays} headerChildren={headerChildren || <>
                  {isFull && <Box className={styles['calendare-header-container']}>
                      <FooterDescription />
                    </Box>}
                </>} />
        </Box>}
      <Box className={styles['calender-mobile-footer-container']} data-sentry-element="Box" data-sentry-source-file="CalendarMobile.tsx">
        {footer ? footer : <>
            <Box className={styles['calender-mobile-footer']}>
              <Box className={styles['calender-mobile-footer-dates']}>
                <Typography variant="bodyM" className={styles['calender-mobile-footer-dates-titles']}>
                  تاریخ ورود
                </Typography>
                <Typography variant="bodyM_Bold" component="p" className={styles['calender-mobile-footer-dates-description']}>
                  {!!checkin && formatTime(checkin)}
                </Typography>
              </Box>
              <Box className={styles['w-100']}>
                <Typography variant="bodyM" className={styles['calender-mobile-footer-dates-titles']}>
                  تاریخ خروج
                </Typography>
                <Typography variant="bodyM_Bold" component="p" className={styles['calender-mobile-footer-dates-description']}>
                  {!!checkout && formatTime(checkout)}
                </Typography>
              </Box>
            </Box>
            <Box className={styles['calender-mobile-footer-buttons']}>
              <Box className={`${styles['calender-mobile-footer-buttons-clear']} ${styles['w-100']}`}>
                {checkin || !isHome ? <Button size="large" disabled={!checkin} format="outlined" onClick={handleReset}>
                    پاک کردن
                  </Button> : <Button size="large" format="outlined" disabled={!isHome} onClick={handlePass}>
                    رد کردن
                  </Button>}
              </Box>
              <Box className={styles['calendar-button']}>
                <Button format="primary" onClick={handleSubmit} size="large" disabled={!checkin || !checkout}>
                  انتخاب تاریخ
                  {checkin && checkout && ` ( ${getDaysBetweenDates(checkin, checkout)} شب ) `}
                </Button>
              </Box>
            </Box>
          </>}
      </Box>
    </Drawer>;
};
export default CalendarMobile;